<template>
    <div class="d-flex align-items-center">
        <template v-if="link == ''">{{ label }}</template>
        <a v-else :href="link" class="text-arclight" :target="target">{{ label }}</a>
    </div>
</template>

<script>
export default {
    props: ["id", "link", "label", "target"],
};
</script>